module.exports = __webpack_public_path__ + "img/kfgx.bb708c5.png";